import {createApiServices} from '@pf126/api-maker'

export default createApiServices({
    baseUrl: window.location.origin.includes('https://labels.merchize.com') ? '/api/labels' : process.env.REACT_APP_API_URL
})
